/*
 *
 * Division constants
 *
 */

export const HAS_DIVISIONS_WATCHER = "app/Division/HAS_DIVISIONS_WATCHER"
export const HAS_DIVISIONS_SUCCESS = "app/Division/HAS_DIVISIONS_SUCCESS"
export const HAS_DIVISIONS_FAILED = "app/Division/HAS_DIVISIONS_FAILED"

export const GET_TABLE_WATCHER = "app/Division/GET_TABLE_WATCHER"
export const GET_TABLE_SUCCESS = "app/Division/GET_TABLE_SUCCESS"
export const GET_TABLE_FAILED = "app/Division/GET_TABLE_FAILED"

export const UPLOAD_TEMPLATE_WATCHER = "app/Division/UPLOAD_TEMPLATE_WATCHER"
export const UPLOAD_TEMPLATE_SUCCESS = "app/Division/UPLOAD_TEMPLATE_SUCCESS"
export const UPLOAD_TEMPLATE_FAILED = "app/Division/UPLOAD_TEMPLATE_FAILED"

export const GET_TEMPLATE_DIVISION_WATCHER =
  "app/Division/GET_TEMPLATE_DIVISION_WATCHER"
export const GET_TEMPLATE_FAILED = "app/Division/GET_TEMPLATE_FAILED"
export const GET_TEMPLATE_SUCCESS = "app/Division/GET_TEMPLATE_SUCCESS"

export const GET_SUBDIVISIONS_TABLE_WATCHER =
  "app/Division/GET_SUBDIVISIONS_TABLE_WATCHER"
export const GET_SUBDIVISIONS_TABLE_SUCCESS =
  "app/Division/GET_SUBDIVISIONS_TABLE_SUCCESS"
export const GET_SUBDIVISIONS_TABLE_FAILED =
  "app/Division/GET_SUBDIVISIONS_TABLE_FAILED"

export const GET_DIVISIONS_UNASSIGNED_WATCHER =
  "app/Division/GET_DIVISIONS_UNASSIGNED_WATCHER"
export const GET_DIVISIONS_UNASSIGNED_SUCCESS =
  "app/Division/GET_DIVISIONS_UNASSIGNED_SUCCESS"
export const GET_DIVISIONS_UNASSIGNED_FAILED =
  "app/Division/GET_DIVISIONS_UNASSIGNED_FAILED"

export const ADD_SUBDIVISION_TABLE_WATCHER =
  "app/Division/ADD_SUBDIVISION_TABLE_WATCHER"
export const ADD_SUBDIVISION_TABLE_SUCCESS =
  "app/Division/ADD_SUBDIVISION_TABLE_SUCCESS"
export const ADD_SUBDIVISION_TABLE_FAILED =
  "app/Division/ADD_SUBDIVISION_TABLE_FAILED"

export const DELETE_SUBDIVISION_TABLE_WATCHER =
  "app/Division/DELETE_SUBDIVISION_TABLE_WATCHER"
export const DELETE_SUBDIVISION_TABLE_SUCCESS =
  "app/Division/DELETE_SUBDIVISION_TABLE_SUCCESS"
export const DELETE_SUBDIVISION_TABLE_FAILED =
  "app/Division/DELETE_SUBDIVISION_TABLE_FAILED"

export const GET_DIVISION_PARENTS_WATCHER =
  "app/Division/GET_DIVISION_PARENTS_WATCHER"
export const GET_DIVISION_PARENTS_FAILED =
  "app/Division/GET_DIVISION_PARENTS_FAILED"
export const GET_DIVISION_PARENTS_SUCCESS =
  "app/Division/GET_DIVISION_PARENTS_SUCCESS"

export const SELECT_DIVISION_SUPERIOR_WATCHER =
  "app/Division/SELECT_DIVISION_SUPERIOR_WATCHER"
export const SELECT_DIVISION_SUPERIOR_SUCCESS =
  "app/Division/SELECT_DIVISION_SUPERIOR_SUCCESS"
export const SELECT_DIVISION_SUPERIOR_FAILED =
  "app/Division/SELECT_DIVISION_SUPERIOR_FAILED"

export const DELETE_DIVISION_TABLE_WATCHER =
  "app/Division/DELETE_DIVISION_TABLE_WATCHER"
export const DELETE_DIVISION_TABLE_SUCCESS =
  "app/Division/DELETE_DIVISION_TABLE_SUCCESS"
export const DELETE_DIVISION_TABLE_FAILED =
  "app/Division/DELETE_DIVISION_TABLE_FAILED"

export const GET_COLLABORATORS_TABLE_WATCHER =
  "app/Division/GET_COLLABORATORS_TABLE_WATCHER"
export const GET_COLLABORATORS_TABLE_SUCCESS =
  "app/Division/GET_COLLABORATORS_TABLE_SUCCESS"
export const GET_COLLABORATORS_TABLE_FAILED =
  "app/Division/GET_COLLABORATORS_TABLE_FAILED"

export const DELETE_DIVISIONS_WATCHER = "app/Division/DELETE_DIVISIONS_WATCHER"
export const DELETE_DIVISIONS_SUCCESS = "app/Division/DELETE_DIVISIONS_SUCCESS"
export const DELETE_DIVISIONS_FAILED = "app/Division/DELETE_DIVISIONS_FAILED"

export const LEAVE_TABLE = "app/Division/LEAVE_TABLE"
export const TOGGLE_TABLE_VIEW = "app/Division/TOGGLE_TABLE_VIEW"

export const CHANGE_EXPANDED_ROWS = "app/Division/CHANGE_EXPANDED_ROWS"
export const RESET_EXPANDED_ROWS = "app/Division/RESET_EXPANDED_ROWS"


export const CREATE_DIVISION_WATCHER = "app/Division/CREATE_DIVISION_WATCHER"
export const CREATE_DIVISION_SUCCESS = "app/Division/CREATE_DIVISION_SUCCESS"
export const CREATE_DIVISION_FAILED = "app/Division/CREATE_DIVISION_FAILED"